import { createFeatureSelector, createSelector } from '@ngrx/store';
import type { MeetingState } from './meeting.models';

export const selectMeetingState = createFeatureSelector<MeetingState>('meeting');

export const selectMeetingLoading = createSelector(
  selectMeetingState,
  (state) => state.loading
);

export const selectCurrentMeetingSession = createSelector(
  selectMeetingState,
  (state) => state.currentSession
);

export const selectIncomingMeetingCall = createSelector(
  selectMeetingState,
  (state) => state.incomingCall
);

export const selectMeetingStatusByChannelId = createSelector(
  selectMeetingState,
  (state) => state.meetingStatusByChannelId
);
